
import React, { useEffect, useState } from 'react';
import { TextField, FormControl, InputLabel, Select, MenuItem, Grid, Paper, useMediaQuery, Button, FormHelperText, CircularProgress } from '@mui/material';
import styled, { inputStyles } from '../../Utils/inputChanges';
import Titlebar from '../TitleBar';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import { Rack, SalePurchaseParty } from '../TitleList';
import { errorStyles } from '../../Utils/table';
import { useDispatch, useSelector } from 'react-redux';
import DateInputComponent from '../FieldsComponents/DateInputComponent';
import { insertRetailerEntry } from '../../Store/PHPSlice/retailerAPi';
import { getCurrentDate } from '../../Utils/Dateutils';
import axios from 'axios';
import { createPricePerEntry } from '../../Store/PHPSlice/Sale/PricePercent';
import PricePercentGrpReg from '../MasterTables/PricePercentageGrpTbl/PricePercentGrpReg';


const PricePercentageGrp = ({ data }) => {
    const userdata = JSON.parse(localStorage.getItem('user'));
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const [formData, setFormData] = useState({
        dt: getCurrentDate(),
        grpId: '',
        userId: userdata?.ID
    });
    const [priceData, setPriceData] = useState({
        actCost: '100',
        scrPer: "",
        scrVal: "",
        milPer: "",
        milVal: "",
        retailerPer: "",
        retailerVal: "",
        mrpPer: "",
        mrpVal: ""
    });
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();

    useEffect(() => {
        fetchGroupId();
    }, []);
    const fetchGroupId = async () => {
        const result = await axios.get(`${baseUrl}?apicall=getPricePercentGroupId`);
        const grpid = result?.data?.data;
        // console.log(grpid)
        setFormData(prev => ({
            ...prev,
            grpId: grpid?.ID
        }))
    }



    const isDesktop = useMediaQuery('(min-width:768px)'); // Adjust the breakpoint as per your requirement

    const handleDateChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };


    const handleInputChange = (e) => {
        const { name, value } = e.target;

        if (name === 'mobno') {
            if (!/^\d*$/.test(value)) {
                return;
            }
        }

        // Ensure contactNo is only 10 digits
        if (name === 'mobno' && value.length > 10) {
            return;
        }

        setFormData({
            ...formData,
            [name]: value.toUpperCase()
        });
    };

    const [errors, setErrors] = useState({});
    const handleSubmit = async (event) => {
        event.preventDefault();
        // console.log(formData);
        // Validate department name

        setLoading(true);

        const postObj = {
            userId: formData.userId,
            dt: formData.dt,
            grpId: formData.grpId,
            actCost: priceData?.actCost,
            scrPer: priceData.scrPer,
            milPer: priceData.milPer,
            retailerPer: priceData.retailerPer,
            mrpPer: priceData.mrpPer
        }

        try {
            const result = await dispatch(createPricePerEntry(postObj)).unwrap();
            console.log('POST request successful!', result);
            alert("Price Percentage Group Added Successful");
            if (data === '1') {
                window.close();
            } else {
                window.location.reload();
            }
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }


    };


    const dropdownFirm = [
        // {
        //     label: 'Firm',
        //     id: 'firmId',
        //     options: firmlist?.data || [],
        //     value: formData.firmId,
        //     onChange: (newValue) => handleDropdownChange({ target: { name: 'firmId', value: newValue ? newValue.ID : '' } }, 'firmId'),
        //     getOptionLabel: (option) => option.firmNm || '',
        //     isOptionEqualToValue: (option, value) => option.ID === value.ID,
        //     valueFinder: (options, value) => {
        //         if (Array.isArray(options)) {
        //             return options.find(item => item.ID === value) || null;
        //         }
        //         return null;
        //     },
        //     errors: errors.firmId
        // },
        // {
        //     label: 'Location',
        //     id: 'locId',
        //     options: loclist?.data || [],
        //     value: formData.locId,
        //     onChange: (newValue) => handleDropdownChange({ target: { name: 'locId', value: newValue ? newValue.ID : '' } }, 'locId'),
        //     getOptionLabel: (option) => option.locNm || '',
        //     isOptionEqualToValue: (option, value) => option.ID === value.ID,
        //     valueFinder: (options, value) => {
        //         if (Array.isArray(options)) {
        //             return options.find(item => item.ID === value) || null;
        //         }
        //         return null;
        //     },
        //     errors: errors.firmId
        // }
    ];

    const handleDropdownChange = (e, dropdownType) => {
        const { value } = e.target;

        setFormData({
            ...formData,
            [dropdownType]: value
        });

    };

    function calculateMRP(percentage, milVal) {
        const per_mrp = percentage / 100;
        const per_mrp2 = 1 - per_mrp;

        if (per_mrp2 <= 0) return 0; // safety check

        const updatemrp = Math.round(milVal / per_mrp2);

        let modVal = updatemrp % 5;
        let ans;

        if (modVal > 2.5) {
            ans = updatemrp + (5 - modVal);
        } else {
            ans = updatemrp - modVal;
        }

        // final rounding to nearest multiple of 5
        return Math.ceil(ans / 5) * 5;
    }
    const percentAdd = (base, per) =>
        Math.round(Number(base) + (Number(base) * Number(per)) / 100);

    const fields = [
        { label: 'Date', name: 'dt', type: 'date' },
        { label: 'Group ID', name: 'grpId', type: 'readOnly' },

    ];
    const handleChange = (e) => {
        const { name, value } = e.target;

        // Make a copy of priceData
        const updated = { ...priceData };
        const percentage = parseFloat(value);


        switch (name) {
            case "scrPer": {
                updated.scrPer = percentage;

                updated.scrVal = percentAdd(updated.actCost, percentage);

                if (updated.milPer) {
                    updated.milVal = percentAdd(updated.scrVal, updated.milPer);
                }

                if (updated.retailerPer) {
                    updated.retailerVal = percentAdd(
                        updated.milVal ?? updated.scrVal,
                        updated.retailerPer
                    );
                }

                if (updated.mrpPer) {
                    updated.mrpVal = calculateMRP(
                        updated.mrpPer,
                        updated.milVal ?? updated.scrVal
                    );
                }
                break;
            }

            case "milPer": {
                updated.milPer = percentage;

                updated.milVal = percentAdd(updated.scrVal, percentage);

                if (updated.retailerPer) {
                    updated.retailerVal = percentAdd(updated.milVal, updated.retailerPer);
                }

                if (updated.mrpPer) {
                    updated.mrpVal = calculateMRP(updated.mrpPer, updated.milVal);
                }
                break;
            }

            case "retailerPer": {
                updated.retailerPer = percentage;

                updated.retailerVal = percentAdd(updated.milVal, percentage);
                break;
            }

            case "mrpPer": {
                updated.mrpPer = percentage;

                updated.mrpVal = calculateMRP(percentage, updated.milVal);
                break;
            }

            default:
                updated[name] = value;
        }

        // console.log(updated)

        // Update state
        setPriceData(updated);
    };




    return (
        <>
            {data === '1' ? null : <Titlebar data={SalePurchaseParty} />}
            <div style={{ margin: '1% 0.5%' }}>
                <h2>Price Percentage - Group Entry</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '3vh', margin: '0' }}>
                            <Grid container spacing={0.5}>

                                {/* {dropdownFirm?.map((drop) => (
                                    <DropdownWithBtn
                                        key={drop.label}
                                        label={drop.label}
                                        id={drop.id}
                                        options={drop.options}
                                        value={drop.value}
                                        onChange={drop.onChange}
                                        isDesktop={isDesktop}
                                        getOptionLabel={drop.getOptionLabel}
                                        isOptionEqualToValue={drop.isOptionEqualToValue}
                                        valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                        errors={drop.errors}
                                    />
                                ))
                                } */}

                                {fields?.map((field) => (
                                    <DateInputComponent
                                        key={field.name}
                                        formData={formData}
                                        handleDateChange={handleDateChange}
                                        handleInputChange={handleInputChange}
                                        styled={styled}
                                        inputStyles={inputStyles}
                                        isDesktop={isDesktop}
                                        field={field}
                                    />
                                ))}


                                <div className="sale-price">
                                    <table className='price-table'>
                                        <thead>
                                            <th>Actual Cost</th>
                                            <th>SCR</th>
                                            <th>MIL</th>
                                            <th>RETAILER</th>
                                            <th>MRP</th>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td><input type="text" value={priceData.actCost} name='actCost' /></td>
                                                <td><input type="text" value={priceData.scrPer} name='scrPer' onChange={handleChange} />%</td>
                                                <td><input type="text" value={priceData.milPer} name='milPer' onChange={handleChange} />%</td>
                                                <td><input type="text" value={priceData.retailerPer} name='retailerPer' onChange={handleChange} />%</td>
                                                <td><input type="number" value={priceData.mrpPer} name='mrpPer' onChange={handleChange} step="any" />MU</td>
                                            </tr>
                                            <tr>
                                                <td> </td>
                                                <td><input type="text" value={priceData.scrVal} /></td>
                                                <td><input type="text" value={priceData.milVal} /></td>
                                                <td><input type="text" value={priceData.retailerVal} /></td>
                                                <td><input type="text" value={priceData.mrpVal} /></td>
                                            </tr>

                                        </tbody>
                                    </table>
                                </div>


                                <Grid item xs={12} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={handleSubmit} disabled={loading === true}>
                                        {
                                            loading === true ?
                                                <><CircularProgress size="20px" /> wait...</> :
                                                "Submit"
                                        }
                                    </Button>
                                </Grid>
                            </Grid>
                            <ToastContainer />
                        </Paper>
                    </Grid>
                </Grid>


            </div>

            {data === '1' ? null : <PricePercentGrpReg />}
        </>
    );
}

export default PricePercentageGrp;
